import { GoodsListPreview, HotListPreview, BenefitPreview, RollingBarragePreview, SearchBarPreview, OperationDialogPreview } from './preview';

export const CompList = [
    {
        name: '广告Banner',
        component: 'Banner',
        img: '/img/mall/banner.svg',
        propsSchema: {
            type: 'object',
            properties: {
                list: {
                    title: '广告Banner配置',
                    type: 'array',
                    widget: 'cardList', 
                    min: 1,
                    max: 5,
                    items: {
                        title: '基础信息',
                        type: 'object',
                        properties: {
                            src: {
                                title: '图片',
                                type: 'string',
                                widget: 'Upload',
                            },
                            link: {
                                title: '跳转页面',
                                type: 'string',
                                widget: 'ChoosePage',
                            }
                        }
                    },
                },
                marginTop: {
                    title: '是否具有上边距',
                    type: 'boolean',
                    widget: 'switch'
                },
            }
        },
        render(props) {
            const { list = [], marginTop } = props;
            // 编辑器预览只展示第一张，避免多张时的排版问题
            const banner = (list && list.length > 0) ? list[0] : null;
            if (!banner) {
                return (
                    <div className="render-banner-empty">
                        请添加Banner图片
                    </div>
                )
            }
            return (
                <div className={`render-banner ${marginTop ? 'mt-4' : ''}`}>
                    <div className="render-banner-item">
                        {banner.src ? (
                            <img
                                src={`https://img.yxdj.tech/${banner.src}`}
                                alt="banner"
                                className="render-banner-image"
                            />
                        ) : (
                            <div className="render-banner-placeholder">Banner</div>
                        )}
                    </div>
                </div>
            )
        }
    },
    {
        name: '运营推广位置(5 或 10个)',
        component: 'Operation',
        img: '/img/mall/operation.svg',
        propsSchema: {
            type: 'object',
            properties: {
                list: {
                    title: '设置推广信息',
                    type: 'array',
                    widget: 'cardList', 
                    min: 5,
                    max: 10,
                    items: {
                        title: '基础信息',
                        type: 'object',
                        properties: {
                            src: {
                                title: '图片',
                                type: 'string',
                                widget: 'Upload',
                            },
                            link: {
                                title: '跳转页面',
                                type: 'array',
                                widget: 'ChoosePage',
                            },
                            title: {
                                title: '标题',
                                type: 'string',
                                widget: 'input',
                            }
                        }
                    },
                },
            }
        },
        render(props) {
            const { list = [] } = props;
            if (!list || list.length === 0) {
                return (
                    <div className="render-operation-empty">
                        请添加推广信息
                    </div>
                )
            }
            return (
                <div className="render-operation">
                    <div className="render-operation-grid">
                        {list.map((item, index) => (
                            <div key={index} className="render-operation-item">
                                {item.src ? (
                                    <img 
                                        src={`https://img.yxdj.tech/${item.src}`} 
                                        alt={item.title || ''}
                                        className="render-operation-image"
                                    />
                                ) : (
                                    <div className="render-operation-placeholder">图标</div>
                                )}
                                {item.title && (
                                    <div className="render-operation-title">{item.title}</div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )
        }
    },
    {
        name: '优惠券展现',
        component: 'Benefit',
        img: '/img/mall/benefit.svg',
        propsSchema: {
            type: 'object',
            properties: {
                couponList: {
                    title: '选择优惠券',
                    type: 'array',
                    widget: 'ChooseCoupon',
                },
            }
        },
        render(props) {
            return <BenefitPreview {...props} />
        }
    },
    {
        name: '热门商品列表',
        component: 'HotList',
        img: '/img/mall/hot-list.svg',
        render(props) {
            return <HotListPreview {...props} />
        }
    },
    {
        name: '图片列表',
        component: 'ImgList',
        img: '/img/mall/img-list.svg',
        propsSchema: {
            type: 'object',
            properties: {
                list: {
                    title: '图片列表',
                    type: 'array',
                    widget: 'cardList', 
                    min: 1,
                    max: 5,
                    items: {
                        title: '基础信息',
                        type: 'object',
                        properties: {
                            src: {
                                title: '图片',
                                type: 'string',
                                widget: 'Upload',
                            },
                            link: {
                                title: '跳转页面',
                                type: 'string',
                                widget: 'ChoosePage',
                            },
                            width: {
                                title: '图片宽度',
                                type: 'number',
                                widget: 'inputNumber'
                            },
                            height: {
                                title: '图片高度',
                                type: 'number',
                                widget: 'inputNumber'
                            }
                        }
                    },
                },
                marginTop: {
                    title: '是否具有上边距',
                    type: 'boolean',
                    widget: 'switch'
                },
            }
        },
        render (props) {
            const { list = [] } = props;
            if (!list || list.length <= 0) {
                return <div className="render-comp-empty">请设置图片信息</div>
            }
            return (
                <div className="render-comp-image-list-content">
                    {
                        list.map((item, index) => {
                            const imgUrl = item.src ? `https://img.yxdj.tech/${item.src}` : '';
                            const style = {};
                            if (item.width) style.width = `${item.width}px`;
                            if (item.height) style.height = `${item.height}px`;
                            
                            return (
                                <div key={index} className="render-comp-image-list-item-wrapper">
                                    {imgUrl ? (
                                        <img 
                                            src={imgUrl} 
                                            alt={`图片${index + 1}`}
                                            className="render-comp-image-list-item"
                                            style={style}
                                        />
                                    ) : (
                                        <div className="render-comp-image-placeholder">图片 {index + 1}</div>
                                    )}
                                </div>
                            )
                        })
                    }
                </div>
            )
        }
    },
    {
        name: '顶部搜索栏',
        component: 'SearchBar',
        img: '/img/mall/search-bar.svg',
        propsSchema: {
            type: 'object',
            properties: {
                canChooseShop: {
                    title: '是否可用选择店铺',
                    type: 'boolean',
                    widget: 'switch'
                }
            }
        },
        render(props) {
            return <SearchBarPreview {...props} />
        }
    },
    {
        name: '商品列表模块',
        component: 'GoodsList',
        img: '/img/mall/goods-list.svg',
        propsSchema: {
            type: 'object',
            properties: {
                title: {
                    title: '标题',
                    type: 'string',
                    widget: 'input',
                },
                goodsIds: {
                    title: '选择商品',
                    type: 'array',
                    widget: 'ChooseGoods',
                },
                column: {
                    title: '展现几列',
                    type: 'string',
                    widget: 'select',
                    props: {
                        options: [
                        { label: '1列', value: '1' },
                        { label: '2列', value: '2' },
                        ]
                    }
                }
            }
        },
        render(props) {
            return <GoodsListPreview {...props} />
        }
    },
    {
        name: '模块标题',
        component: 'ModuleTitle',
        img: '/img/mall/module-title.svg',
        propsSchema: {
            type: 'object',
            properties: {
                title: {
                    title: '标题',
                    type: 'string',
                    widget: 'input',
                },
            }
        },
        render(props) {
            const { title = '请设置标题' } = props;
            return (
                <div className="render-module-title">
                    <h3>{title}</h3>
                </div>
            )
        }
    }, 
    {
        name: '已售消息轮播',
        component: 'RollingBarrage',
        img: '/img/mall/buy-list.svg',
        render(props) {
            return <RollingBarragePreview {...props} />
        }
    },
    {
        name: '开屏弹框',
        component: 'OperationDialog',
        img: '/img/mall/dialog.svg',
        propsSchema: {
            type: 'object',
            properties: {
                showList: {
                    title: '内容配置（按顺序优先展现）',
                    type: 'array',
                    widget: 'cardList', 
                    min: 1,
                    max: 5,
                    items: {
                        title: '弹框内容',
                        type: 'object',
                        properties: {
                            type: {
                                title: '内容',
                                type: 'string',
                                widget: 'select',
                                props: {
                                    options: [
                                        { label: '优惠券', value: 'coupon' },
                                        { label: '次卡', value: 'goodsCard' },
                                        // { label: '商品', value: 'goods' },
                                        { label: '图片', value: 'other' },
                                    ]
                                }
                            },
                            goodsCardIds: {
                                title: '选择展现次卡',
                                tooltip: '需要配置图片',
                                extra:  '若用户已购买且未使用完，则不会展现，按选择顺序依次展现',
                                type: 'array',
                                widget: 'ChooseGoodsCard',
                                hidden: '{{ rootValue.type!== "goodsCard" }}'
                            },
                            couponIds: {
                                title: '选择优惠券',
                                extra:  '若用户当前不可领取这些优惠券，则不会展现',
                                type: 'array',
                                widget: 'ChooseCoupon',
                                hidden: '{{ rootValue.type!== "coupon" }}'
                            },
                            // goodsId: {
                            //     title: '选择商品',
                            //     type: 'string',
                            //     multi: false,
                            //     widget: 'ChooseGoods'
                            // },
                            image: {
                                title: '展现图片',
                                type: 'string',
                                widget: 'Upload',
                                required: true,
                                hidden: '{{ rootValue.type === "coupon" || !rootValue.type }}'
                            },
                            link: {
                                title: '点击后跳转页面',
                                type: 'string',
                                widget: 'ChoosePage',
                                required: true,
                                hidden: '{{ rootValue.type !== "other" }}'
                            }
                        }
                    },
                }
            }
        },
        render(props) {
            return <OperationDialogPreview {...props} />
        }
    },
]